export enum AccessCodeType {
    FleetOperatorCode = 10,
    SharedWalletCode = 20,
    ChargingStationAccessCode = 30,
}
